import axios from 'axios';
import { getPhoto } from '~/services/base';
import { parseBool } from "~/services/booleanParser";
export async function getCategoriesTree(filter) {
  return axios.get('/categories/tree' + filter)
    .then(response => {
      return response.data;
    })
    .catch(exception => {
      return exception.response;
    })
}

export async function getCategory(categoryId) {
  return axios.get('/categories/' + categoryId + '?expand=attrs,seo')
    .then(response => {
      return response.data;
    })
    .catch(exception => {
      return exception.response;
    })
}

export function makeAvailableValuesStaff(offersApiResponse) {
  let offers = offersApiResponse;

  for (let i = 0; i < offers.items.length; i++) {
    if (offers.items[i].user) {
      offers.items[i].user.photo = offers.items[i].user.photo_uploaded_at ? getPhoto(offers.items[i].user.id, offers.items[i].user.photo_uploaded_at) : null;
    }

    //offers.items[i].calculateStatus = false;
    //offers.items[i].calculatedTime = null;
    //offers.items[i].calculatedPrice = null;
    //offers.items[i].attrs = [];
  }
  try {
    offers.items.forEach(function (item, index) {
      if (item.offerToAttrs) {
        for (let i = 0; i < item.offerToAttrs.length; i++) {
          let offerAttr = item.offerToAttrs[i];

          for (let n = 0; n < item.attrs.length; n++) {
            let attrs = item.attrs[n];

            if (offerAttr.attr && offerAttr.attr.id == attrs.id) {
              // TYPE 0
              // Записываем значения для чекбокса
              if (attrs.type == 0) {
                attrs.value = offerAttr.price_formula;
                attrs.time = offerAttr.time_formula / 60;
                if (parseInt(offerAttr.value) === 1) {
                  attrs.checked = 1;
                } else {
                  attrs.checked = 0;
                }
              }

              // TYPE 1
              // Записываем значения range
              if (attrs.type == 1) {
                // Записываем значение для текстового инпута
                if (attrs.view == null) {
                  attrs.value = offerAttr.value;
                }

                let itemsPriceArray;
                let itemsPrice;
                let itemsTimeArray;
                let itemsTime;
                // Парсим формулы цены и времени
                if (offerAttr.price_formula != null) {
                  itemsPriceArray = offerAttr.price_formula.split(", ");
                  itemsPrice = eval("({" + itemsPriceArray + "})");
                }
                if (offerAttr.time_formula != null) {
                  itemsTimeArray = offerAttr.time_formula.split(", ");
                  itemsTime = eval("({" + itemsTimeArray + "})");
                }
                for (let index in itemsTime) {
                  itemsTime[index] = itemsTime[index] / 60;
                }
                // Если есть предопределенные значения (availableValues)
                if (
                  offerAttr.attr.view == 3 &&
                  attrs.availableValues.length > 0
                ) {
                  let indexPrice = 0;
                  let indexTime = 0;
                  for (let key in itemsPrice) {
                    if (offerAttr.attr.view == 3 && offerAttr.attr.type == 1) {
                      let keySplit = key.split(",");
                      let firstAvailable = parseInt(keySplit[0]);
                      let secondAvailable = parseInt(keySplit[1]);
                      if (firstAvailable) {
                        if (!attrs.availableValues[firstAvailable - 1].content) {
                          attrs.availableValues[firstAvailable - 1].content = {};
                        }

                        attrs.availableValues[firstAvailable - 1].content.price =
                          itemsPrice[key];
                        attrs.availableValues[firstAvailable - 1].content.time =
                          itemsTime[key];
                      }

                      if (secondAvailable) {
                        if (!attrs.availableValues[secondAvailable - 1].content) {
                          attrs.availableValues[secondAvailable - 1].content = {};
                        }

                        attrs.availableValues[secondAvailable - 1].content.price =
                          itemsPrice[key];
                        attrs.availableValues[secondAvailable - 1].content.time =
                          itemsTime[key];

                      }
                    } else {
                      if (!attrs.availableValues[indexPrice].content) {
                        attrs.availableValues[indexPrice].content = {};
                      }
                      attrs.availableValues[indexPrice].content.price =
                        itemsPrice[key];
                      attrs.availableValues[indexTime].content.time =
                        itemsTime[key];
                      indexPrice++;
                      indexTime++;
                    }
                  }
                }

                // Если нет предопределенных значений записываем обычный range
                else {
                  if (
                    itemsPriceArray != undefined &&
                    itemsPriceArray.length != 0
                  ) {
                    for (let key in itemsPrice) {
                      let range = key.split(",");
                      let time =
                        itemsTimeArray != undefined && itemsTimeArray.length != 0
                          ? itemsTime[key]
                          : null;
                      if (!attrs.range) {
                        attrs.range = Array();
                      }
                      attrs.range.push({
                        from: range[0],
                        to: range[1],
                        price: itemsPrice[key],
                        time: time
                      });
                    }
                  } else {
                    for (let key in itemsTime) {
                      let price =
                        itemsPriceArray != undefined &&
                          itemsPriceArray.length != 0
                          ? itemsPrice[key]
                          : null;
                      if (!attrs.range) {
                        attrs.range = Array();
                      }
                      let range = key.split(",");
                      attrs.range.push({
                        from: range[0],
                        to: range[1],
                        price: price,
                        time: itemsTime[key]
                      });
                    }
                  }
                }
              }

              // TYPE 2
              if (attrs.type == 2) {
                if (attrs.view == null) {
                  attrs.value = offerAttr.value;
                }
              }

              // TYPE 3

              if (attrs.type == 3) {
                // MultiSelectNoFilled
                if (
                  attrs.view == null ||
                  (attrs.affects_price == 0 && attrs.affects_time == 0)
                ) {
                  if (offerAttr.price_formula != null) {
                    let itemsPrice = offerAttr.available_value_id
                      .replace("[", "")
                      .replace("]", "")
                      .split(",");
                    for (
                      let index = 0;
                      index < attrs.availableValues.length;
                      index++
                    ) {
                      for (
                        let indexAv = 0;
                        indexAv < itemsPrice.length;
                        indexAv++
                      ) {
                        if (
                          itemsPrice[indexAv] == attrs.availableValues[index].id
                        ) {
                          attrs.availableValues[index].check = 1;
                        }
                      }
                    }
                  }
                }
                // MultiSelect
                else {
                  let itemsPrice;
                  let itemsTime;
                  if (offerAttr.price_formula != null) {
                    itemsPrice = offerAttr.price_formula.split(", ");
                    itemsPrice = eval("({" + itemsPrice + "})");
                  }
                  if (offerAttr.time_formula != null) {
                    itemsTime = offerAttr.time_formula.split(", ");
                    itemsTime = eval("({" + itemsTime + "})");
                  }
                  for (let index in itemsTime) {
                    itemsTime[index] = itemsTime[index] / 60;
                  }
                  for (let k = 0; k < attrs.availableValues.length; k++) {
                    if (
                      itemsPrice != undefined &&
                      itemsPrice[attrs.availableValues[k].id]
                    ) {
                      let key = attrs.availableValues[k].id;
                      attrs.availableValues[k].check = 1;
                      if (!attrs.availableValues[k].content) {
                        attrs.availableValues[k].content = {};
                      }
                      attrs.availableValues[k].content.price = itemsPrice[key];
                    }
                    if (
                      itemsTime != undefined &&
                      itemsTime[attrs.availableValues[k].id]
                    ) {
                      let key = attrs.availableValues[k].id;
                      attrs.availableValues[k].check = 1;
                      if (attrs.availableValues[k].content) {
                        attrs.availableValues[k].content = {};
                      }
                      attrs.availableValues[k].content.time = itemsTime[key];
                    }
                  }
                }
              }
              // TYPE 4
              if (attrs.type == 4) {
                attrs.value = offerAttr.available_value_id
                  .replace("[", "")
                  .replace("]", "");
              }
            }
          }
        }
      }
    });

    return offers;
  }
  catch (error) {
    console.log(error);
  }
}

export async function getOfferList(filter, filtersRequestData = null) {
  if (Array.isArray(filter)) {
    filter = filter.join('&');
  }


  if (typeof filter === 'object') {
    let tmpFilter = '';
    for (let [key, value] of Object.entries(filter)) {
      if (value) {
        tmpFilter += key + '=' + value + '&'
      }
    }

    filter = tmpFilter;
  }

  if (filter.slice(filter.length - 1) !== '&') {
    filter += '&';
  }

  let response;

  let filtersRequest = { filters: [], attributesValues: {} };
  if (filtersRequestData) {
    filtersRequestData.forEach(item => {
      if (item.filters && (item.affects_price == 0 &&
        item.affects_time == 0)) {
        if (item.type == 0) {
          filtersRequest.filters.push({
            attributeId: item.id,
            filter: parseBool(item.filters.yes) == true ? 1 : 0
          })
        }

        if (item.type == 1) {
          filtersRequest.filters.push({
            attributeId: item.id,
            filter: [parseInt(item.filters.rangeMultiple.from), parseInt(item.filters.rangeMultiple.to)]
          })
        }

        if (item.type == 2 && item.view == null) {
          filtersRequest.filters.push({
            attributeId: item.id,
            filter: [parseInt(item.filters.rangeMultiple.from), parseInt(item.filters.rangeMultiple.to)]
          })
        }

        if ((item.type == 3 && item.view != 6) || item.type == 4) {
          let multisSelectKeys = Object.keys(item.filters.multiselect);
          let toFilter = [];

          multisSelectKeys.forEach(fil => {
            fil = parseInt(fil);
            if (parseBool(item.filters.multiselect[fil]) == true) {
              toFilter.push(fil);
            }
          });
          filtersRequest.filters.push({
            attributeId: parseInt(item.id),
            filter: toFilter
          })
        }

        if (item.type == 3 && item.view == 6) {
          filtersRequest.filters.push({
            attributeId: parseInt(item.id),
            filter: parseInt(item.filters.select)
          })
        }
      }

      if (item.filters.attributesValues && Object.keys(item.filters.attributesValues) > 0) {
        filtersRequest.attributesValues[Object.keys(item.filters.attributesValues)[0]] = item.filters.attributesValues[Object.keys(item.filters.attributesValues)[0]];
      }

    });
  }

  try {
    response = await axios.post('/offers/find?' + filter + 'expand=offerToAttrs,customAttrs,attrs,user,category,slugName,reviewsCount,game', filtersRequest);
  } catch (e) {
    return e.data;
  }

  if (response.data && response.data.success) {
    let offersCount = response.data.data._meta.totalCount;
    let offers = makeAvailableValuesStaff(response.data.data);
    offers.items.forEach((item) => {
      if (item.price && item.price > 0 && item.time && item.time > 0) {
        item.calculateStatus = true;
      }

    });

    return {
      offers: offers,
      offersCount: offersCount
    };
  } else {

    return response.data.error;
  }
}